export const THEME_STORAGE_KEY = "fox-crafting-theme";

export const appThemes = {
  light: {
    id: "light",
    label: "Light",
    mode: "light",
    colors: {
      pageBg: "#ffffff",
      surface: "#ffffff",
      surfaceSoft: "#f8fafc",
      surfaceMuted: "#f1f5f9",
      text: "#172033",
      textMuted: "#64748b",
      textFaint: "#94a3b8",
      border: "#e2e8f0",
      borderSoft: "#edf1f5",
      accent: "#4f46e5",
      accentSoft: "#eef2ff",
      accentStrong: "#4338ca",
      primary: "#4f46e5",
      primaryStrong: "#4338ca",
      primaryText: "#ffffff",
      danger: "#dc2626",
      dangerSoft: "#fef2f2",
      success: "#15803d",
      successSoft: "#dcfce7",
      shadow: "rgba(15, 23, 42, 0.08)",
      overlay: "rgba(15, 23, 42, 0.46)",
      taskCard: "#e9e9e9",
      taskInner: "#ffffff",
      timer: "#626262",
    },
  },
  dark: {
    id: "dark",
    label: "Dark",
    mode: "dark",
    colors: {
      pageBg: "#000000",
      surface: "#0b0b0f",
      surfaceSoft: "#111113",
      surfaceMuted: "#1a1a1f",
      text: "#f8fafc",
      textMuted: "#c7c7d1",
      textFaint: "#8b8b96",
      border: "#2a2a31",
      borderSoft: "#1d1d23",
      accent: "#a5b4fc",
      accentSoft: "#181824",
      accentStrong: "#c7d2fe",
      primary: "#4f46e5",
      primaryStrong: "#4338ca",
      primaryText: "#ffffff",
      danger: "#f87171",
      dangerSoft: "#3f1d24",
      success: "#86efac",
      successSoft: "#173923",
      shadow: "rgba(0, 0, 0, 0.36)",
      overlay: "rgba(0, 0, 0, 0.74)",
      taskCard: "#111113",
      taskInner: "#0f0f12",
      timer: "#d8d8df",
    },
  },
};

export const themeOptions = Object.values(appThemes);

export const getAppTheme = (themeId) => appThemes[themeId] || appThemes.light;

export const themeToCssVars = (theme) => {
  const colors = theme.colors;

  return {
    "--app-bg": colors.pageBg,
    "--app-surface": colors.surface,
    "--app-surface-soft": colors.surfaceSoft,
    "--app-surface-muted": colors.surfaceMuted,
    "--app-text": colors.text,
    "--app-text-muted": colors.textMuted,
    "--app-text-faint": colors.textFaint,
    "--app-border": colors.border,
    "--app-border-soft": colors.borderSoft,
    "--app-accent": colors.accent,
    "--app-accent-soft": colors.accentSoft,
    "--app-accent-strong": colors.accentStrong,
    "--app-primary": colors.primary,
    "--app-primary-strong": colors.primaryStrong,
    "--app-primary-text": colors.primaryText,
    "--app-danger": colors.danger,
    "--app-danger-soft": colors.dangerSoft,
    "--app-success": colors.success,
    "--app-success-soft": colors.successSoft,
    "--app-shadow": colors.shadow,
    "--app-overlay": colors.overlay,
    "--task-card-bg": colors.taskCard,
    "--task-inner-bg": colors.taskInner,
    "--timer-color": colors.timer,
    "--color-mode": colors.text,
  };
};

export const legacyColorThemes = {
  classic: {
    backgroundColor: appThemes.light.colors.pageBg,
    secondaryBackgroundColor: appThemes.light.colors.surfaceSoft,
    listItemColor: appThemes.light.colors.taskCard,
    iconColor: appThemes.light.colors.accent,
    textNameColor: appThemes.light.colors.text,
    timerColor: appThemes.light.colors.timer,
  },
  light: {
    backgroundColor: appThemes.light.colors.pageBg,
    secondaryBackgroundColor: appThemes.light.colors.surfaceSoft,
    listItemColor: appThemes.light.colors.taskCard,
    iconColor: appThemes.light.colors.accent,
    textNameColor: appThemes.light.colors.text,
    timerColor: appThemes.light.colors.timer,
  },
  dark: {
    backgroundColor: appThemes.dark.colors.pageBg,
    secondaryBackgroundColor: appThemes.dark.colors.surfaceSoft,
    listItemColor: appThemes.dark.colors.taskCard,
    iconColor: appThemes.dark.colors.accent,
    textNameColor: appThemes.dark.colors.text,
    timerColor: appThemes.dark.colors.timer,
  },
};
